import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import FilterForm from "../../../components/FilterForm";
import { getReportDescription } from "../../../store/helpers";
import Loader from "../../../components/loader";
import BranchServiceTimePerServiceReport from "../../../components/branches/reports/daily/BranchServiceTimePerService";
import _ from "lodash";

const BranchServiceTimePerService = ({
  showFilterForm = true,
  reportIndex = 1,
}) => {
  const { reportRange, loading, tickets, branches, organizationId, branchId } =
    useSelector((state) => state.defaultReducer);
  let branchesClone = _.cloneDeep(branches);
  branchesClone = branchesClone
    .filter(
      (a) =>
        a.reportStatus != null &&
        Number(a.reportStatus) &&
        a.organizationId === organizationId
    )
    .filter((a) => !branchId.length || (branchId.length && a.id === branchId));
  const reportTitle = `${reportIndex}. Service Time Per Service`;
  console.log(reportTitle);
  return (
    <Box>
      {showFilterForm ? <FilterForm /> : <></>}
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {" "}
          {tickets.length ? (
            <>
              <h1>{reportTitle}</h1>
              <p>
                {
                  getReportDescription(reportRange)
                    .ServiceTimePerServiceBranches
                }
              </p>

              {branchesClone?.map((a, i) => {
                return (
                  <BranchServiceTimePerServiceReport
                    key={a.id}
                    reportIndex={reportIndex}
                    branchId={a.id}
                    branchIndex={i + 1}
                  />
                );
              })}
            </>
          ) : (
            <Box mt={10}>
              <p>No data available in this search</p>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default BranchServiceTimePerService;
